const baseUrl = 'intake';

export const ApiIntake = {
  GetAll: `${baseUrl}`,
  Enroll: `${baseUrl}/enroll`
};
